import { createSelector } from '@reduxjs/toolkit';
import { CandleWorker } from 'client/voladeum/candle-workers/types';
import { RootState } from 'store';

const candleWorkersSlice = (state: RootState) => state.candle_workers;

export const selectCandleWorkers = createSelector(
  [candleWorkersSlice],
  (state): CandleWorker[] => state
);
